import type {PositionedAdvancedMarkerElement} from "./helpers";

export const enum InfoWindowPositionResetMethod {
	NONE,
	RETURN,
	CLEAR
}
export const infoWindowContentClass = 'queryLoopGoogleMap__infoWindowContent';

export class InfoWindowManager {
	private readonly infoWindow = new google.maps.InfoWindow();

	public constructor(private readonly map: google.maps.Map) {
		// We use drag instead of center_changed because we only want to detect user-initiated changes.
		map.addListener('drag', () => this.infoWindow.set('originalPosition', null));

		// This works because the click event will only trigger when the map itself is clicked.
		map.addListener('click', () => this.closeInfoWindow(InfoWindowPositionResetMethod.RETURN));
	}

	public openInfoWindow(marker: PositionedAdvancedMarkerElement, element: HTMLElement) {
		this.closeInfoWindow(InfoWindowPositionResetMethod.NONE);
		if (!this.infoWindow.get('originalPosition')) {
			this.infoWindow.set('originalPosition', this.map.getBounds());
		}
		const infoWindowContent = element.classList.contains(infoWindowContentClass) ? element : element.querySelector(`.${infoWindowContentClass}`);
		if (infoWindowContent) {
			this.infoWindow.setContent(infoWindowContent.cloneNode(true) as Element);
			this.infoWindow.open(this.map, marker);
		}
	}

	public closeInfoWindow(resetPosition: InfoWindowPositionResetMethod) {
		this.infoWindow.close();
		if (resetPosition) {
			if (this.infoWindow.get('originalPosition')) {
				if (resetPosition === InfoWindowPositionResetMethod.RETURN) {
					this.map.fitBounds(this.infoWindow.get('originalPosition'), 0);
				}
				this.infoWindow.set('originalPosition', null);
			}
		}
	}
}
